module.exports = __webpack_public_path__ + "img/logo.8d748fe4.png";